import * as types from '../constants/lossScenarioMappingGwToDigital';

export const getClaimType = (language, claimLossScenarioLevel, claimType) => {
  if (claimType === 'auto') {
    if (language === 'fr') {
      return types.autoLossScenarioMappingsFR[claimLossScenarioLevel];
    }
    return types.autoLossScenarioMappings[claimLossScenarioLevel];
  }
  if (claimType === 'property') {
    if (language === 'fr') {
      return types.propLossScenarioMappingsFR[claimLossScenarioLevel];
    }
    return types.propLossScenarioMappings[claimLossScenarioLevel];
  }
};
